module.exports = __webpack_public_path__ + "img/icon-port.44c14f35.svg";